import { apiFetch } from './client';

// Keep in sync with backend/src/payments/recurringService.ts — quarterly +
// annually were added in migration 0070 (Sam's cadences).
export type RecurringPeriod =
  | 'daily' | 'weekly' | 'biweekly' | 'monthly' | 'bimonthly'
  | 'quarterly' | 'annually';
export type RecurringStatus = 'active' | 'paused' | 'completed' | 'failed' | 'cancelled';

export interface RecurringScheduleRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  caller_id: string | null;
  gateway_id: string;
  card_id: string | null;
  ivr_node_id: string | null;
  amount_cents: number;
  currency: string;
  period: RecurringPeriod;
  total_count: number | null;
  charged_count: number;
  status: RecurringStatus;
  next_charge_at: string;
  last_charge_at: string | null;
  last_attempt_at: string | null;
  retry_failed: boolean;
  retry_schedule: number[];
  retry_at: string | null;
  retry_count: number;
  description: string | null;
  created_at: string;
  updated_at: string;
}

export const recurringSchedules = {
  list: (p: { customer_id?: string; caller_id?: string; status?: RecurringStatus; limit?: number } = {}) => {
    const q = new URLSearchParams();
    for (const [k, v] of Object.entries(p)) { if (v !== undefined && v !== '') q.set(k, String(v)); }
    return apiFetch<{ rows: RecurringScheduleRow[] }>(`/api/recurring-schedules?${q}`);
  },
  get: (id: string) => apiFetch<RecurringScheduleRow>(`/api/recurring-schedules/${id}`),
  update: (id: string, patch: Partial<{ status: 'active' | 'paused' | 'cancelled'; amount_cents: number; next_charge_at: string; retry_failed: boolean }>) =>
    apiFetch<RecurringScheduleRow>(`/api/recurring-schedules/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  remove: (id: string) => apiFetch<void>(`/api/recurring-schedules/${id}`, { method: 'DELETE' }),
};
